import SearchableCountrySelect from "../../../components/SearchableCountrySelect";
import { useEffect, useState } from "react";
import { get, patchRequest } from "../../../http/api";

export default function PreferencesSection() {
    const [prefs, setPrefs] = useState({
        roles: [],
        country: "",
        sport: "",
        level: "",
        show_stats: true,
        show_highlights: true,
        show_club: true,
        allow_feed_suggestions: true
    });

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [open, setOpen] = useState(false);

    /* FETCH */
    useEffect(() => {
        fetchPreferences();
    }, []);

    // const fetchPreferences = async () => {
    //     try {
    //         const res = await get("profile/preferences");
    //         setPrefs({ ...prefs, ...res.data });
    //     } catch (err) {
    //         console.error(err);
    //     }
    // };

    const fetchPreferences = async () => {
        try {
            const res = await get("profile/preferences");

            setPrefs(prev => ({
                ...prev,
                ...res.data,
                roles: Array.isArray(res.data.roles) ? res.data.roles : []
            }));
        } catch (err) {
            console.error(err);
        }
    };

    /* HANDLERS */
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setPrefs({
            ...prefs,
            [name]: type === "checkbox" ? checked : value
        });
        setSuccess(false);
    };

    const toggleRole = (role) => {
        setPrefs((prev) => ({
            ...prev,
            roles: prev.roles.includes(role)
                ? prev.roles.filter((r) => r !== role)
                : [...prev.roles, role]
        }));
        setSuccess(false);
    };

    /* SAVE */
    const handleSave = async () => {
        setLoading(true);
        try {
            await patchRequest("profile/preferences", prefs);
            setSuccess(true);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="settings-card">
            <h3>Préférences & visibilité</h3>

            {/* MATCHING PREFS */}
            <h4>Préférences de matching</h4>

            <label>Rôles recherchés</label>
            <div className="role-selector">
                {["athlete", "club", "brand", "lawyer"].map((role) => (
                    <button
                        key={role}
                        className={
                            prefs.roles.includes(role)
                                ? "role-btn active"
                                : "role-btn"
                        }
                        onClick={() => toggleRole(role)}
                        type="button"
                    >
                        {role}
                    </button>
                ))}
            </div>

            <label>Pays préféré</label>
            <SearchableCountrySelect
                name="country"
                value={prefs.country}
                onChange={handleChange}
                placeholder="Pays préféré"
            />

            <label>Sport ciblé</label>
            <input
                name="sport"
                value={prefs.sport}
                onChange={handleChange}
                placeholder="Ex: Football"
            />

            <div className="dropdown">
                <label>Niveau minimum</label>

                <div
                    className="dropdown-header"
                    onClick={() => setOpen(!open)}
                >
                    <span>
                        {prefs.level || "Tous niveaux"}
                    </span>
                    <span className="arrow">⌄</span>
                </div>

                {open && (
                    <div className="dropdown-menu">
                        {["Tous niveaux", "amateur", "semi-pro", "pro"].map((lvl) => (
                            <div
                                key={lvl}
                                className="dropdown-item"
                                onClick={() => {
                                    setPrefs({ ...prefs, level: lvl === "Tous niveaux" ? "" : lvl });
                                    setOpen(false);
                                }}
                            >
                                {lvl}
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* VISIBILITY */}
            <h4>Visibilité du profil</h4>

            <div className="toggle-row" onClick={() =>
                setPrefs(prev => ({ ...prev, show_stats: !prev.show_stats }))
            }>
                <span>Afficher mes stats</span>

                <label className="switch">
                    <input
                        type="checkbox"
                        checked={prefs.show_stats}
                        onChange={() => { }}
                    />
                    <span className="slider"></span>
                </label>
            </div>

            <div className="toggle-row" onClick={() =>
                setPrefs(prev => ({ ...prev, show_highlights: !prev.show_highlights }))
            }>
                <span>Afficher mes highlights</span>

                <label className="switch">
                    <input
                        type="checkbox"
                        checked={prefs.show_highlights}
                        onChange={() => { }}
                    />
                    <span className="slider"></span>
                </label>
            </div>

            <div className="toggle-row" onClick={() =>
                setPrefs(prev => ({ ...prev, show_club: !prev.show_club }))
            }>
                <span>Afficher mon club actuel</span>

                <label className="switch">
                    <input
                        type="checkbox"
                        checked={prefs.show_club}
                        onChange={() => { }}
                    />
                    <span className="slider"></span>
                </label>
            </div>

            <div className="toggle-row" onClick={() =>
                setPrefs(prev => ({ ...prev, allow_feed_suggestions: !prev.allow_feed_suggestions }))
            }>
                <span>Autoriser les suggestions dans le feed</span>

                <label className="switch">
                    <input
                        type="checkbox"
                        checked={prefs.allow_feed_suggestions}
                        onChange={() => { }}
                    />
                    <span className="slider"></span>
                </label>
            </div>

            <div className="settings-actions">
                <button
                    className="btn primary"
                    onClick={handleSave}
                    disabled={loading}
                >
                    {loading ? "Enregistrement..." : "Enregistrer"}
                </button>

                {success && <span className="success-msg">✔ Sauvegardé</span>}
            </div>
        </section>
    );
}